import type { AiImageAnnotation } from "../schema"
import type { AnnotationBadge, BoxGeometry } from "./geometry"
import { buildAnnotationGeometry } from "./geometry"

export const ANNOTATION_ACCENT = "#4CB782"
export const ANNOTATION_HALO = "#FFFFFF"
export const ANNOTATION_HALO_OPACITY = 0.85
export const annotationHaloWidth = (strokeWidth: number) => strokeWidth * 2.1

export interface AnnotatedImageMeta {
	width: number
	height: number
	annotations: AiImageAnnotation[]
}

/**
 * One drawing backend: the SVG overlay in chat, the sharp raster for baked
 * emails, or whatever renders marks next. Backends only draw primitives; what
 * gets drawn where is decided once, in drawAnnotations.
 */
export interface AnnotationCanvas {
	drawBox(geometry: BoxGeometry): void
	drawBadge(badge: AnnotationBadge, strokeWidth: number): void
}

export function drawAnnotations(
	canvas: AnnotationCanvas,
	image: AnnotatedImageMeta,
): void {
	for (const annotation of image.annotations) {
		const geometry = buildAnnotationGeometry(
			annotation,
			image.width,
			image.height,
		)
		canvas.drawBox(geometry)
		if (geometry.badge) canvas.drawBadge(geometry.badge, geometry.strokeWidth)
	}
}
